import type { LocationKey } from 'src/app/v1/views/pages/MultiLocation/type';

export const locationIds: Array<LocationKey> = [
  'location1',
  'location2',
  'location3',
  'location4',
  'location5',
];

export const multiLocations = {
  [locationIds[0]]: {
    jobLocationId: '',
    jobLocationText: '',
    isErrorWhenPosting: false,
  },
  [locationIds[1]]: {
    jobLocationId: '',
    jobLocationText: '',
    isErrorWhenPosting: false,
  },
  [locationIds[2]]: {
    jobLocationId: '',
    jobLocationText: '',
    isErrorWhenPosting: false,
  },
  [locationIds[3]]: {
    jobLocationId: '',
    jobLocationText: '',
    isErrorWhenPosting: false,
  },
  [locationIds[4]]: {
    jobLocationId: '',
    jobLocationText: '',
    isErrorWhenPosting: false,
  },
};
